export class CaptainsDocument {
    constructor(captainsDocumentId: number, reportName: string, reportHeading: string, printMethodName: string) {
        this.captainsDocumentId = captainsDocumentId;
        this.reportName = reportName;
        this.reportHeading = reportHeading;
        this.printMethodName = printMethodName;
    }
    captainsDocumentId: number;
    reportName: string;
    reportHeading: string;
    printMethodName: string;
}
